import { List } from "@mantine/core";
import type { components } from "../../../../../types/api.types";
import type { Paragraph6CreditErrorMessageDetailProps } from "../Paragraph6CreditErrorMessage";
import { formatMissingPeriods } from "./utils/formatMissingPeriods";
import { groupMissingValues } from "./utils/groupMissingValues";

export type NetztransparenzMissingValue =
  components["schemas"]["NetztransparenzMissingValue"];

function NetztransparenzValuesError({
  paragraph6CreditErrors
}: Paragraph6CreditErrorMessageDetailProps) {
  const transparenzValuesErrors = paragraph6CreditErrors.filter(
    ({ netztransparenz_values_missing }) =>
      netztransparenz_values_missing.jahresmarktwerte_missing?.length ||
      netztransparenz_values_missing.monatsmarktwerte_missing?.length ||
      netztransparenz_values_missing.p51_rules_missing?.length
  );

  // render null if there are no transparenzValues errors
  if (transparenzValuesErrors.length === 0) {
    return null;
  }

  const uniqueJahresmarktwerteMissing = groupMissingValues(
    transparenzValuesErrors.flatMap(
      (error) =>
        error.netztransparenz_values_missing.jahresmarktwerte_missing || []
    )
  );

  const uniqueMonatsmarktwerteMissing = groupMissingValues(
    transparenzValuesErrors.flatMap(
      (error) =>
        error.netztransparenz_values_missing.monatsmarktwerte_missing || []
    )
  );

  const uniqueP51RulesMissing = groupMissingValues(
    transparenzValuesErrors.flatMap(
      (error) => error.netztransparenz_values_missing.p51_rules_missing || []
    )
  );

  return (
    <List.Item>
      Externe Marktdaten:
      <List withPadding>
        {uniqueJahresmarktwerteMissing.map((item, idx) => (
          <List.Item key={`jahresmarktwert-${idx}`}>
            {item?.label} für {formatMissingPeriods(item?.periods)}
          </List.Item>
        ))}
        {uniqueMonatsmarktwerteMissing.map((item, idx) => (
          <List.Item key={`monatsmarktwert-${idx}`}>
            {item?.label} für {formatMissingPeriods(item?.periods)}
          </List.Item>
        ))}
        {uniqueP51RulesMissing.map((item, idx) => (
          <List.Item key={`p51rule-${idx}`}>
            Negative Spotmarktpreise ({item?.label}) für{" "}
            {formatMissingPeriods(item?.periods)}
          </List.Item>
        ))}
      </List>
    </List.Item>
  );
}

export { NetztransparenzValuesError };
